// Action Types
import {actionTypes} from '../action-types';

export const setMode = mode => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        mode,
      },
      type: actionTypes.FOLDER_SET_MODE,
    })
  );

export const addDataPackage = dataPackage => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        dataPackage,
      },
      type: actionTypes.FOLDER_ADD_DATA_PACKAGE,
    })
  );

export const removeDataPackage = dataPackageId => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        dataPackageId,
      },
      type: actionTypes.FOLDER_REMOVE_DATA_PACKAGE,
    })
  );

export const setFolderData = folderData => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        folderData,
      },
      type: actionTypes.FOLDER_SET_DATA,
    })
  );

export const viewFolder = folderData => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        folderData,
      },
      type: actionTypes.FOLDER_VIEW,
    })
  );

export const createFolder = parentFolderId => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        parentFolderId,
      },
      type: actionTypes.FOLDER_CREATE,
    })
  );

export const updateFolder = folderData => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        folderData,
      },
      type: actionTypes.FOLDER_UPDATE,
    })
  );

export const deleteFolder = (folderToDelete, isSubFolder = true) => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        folderToDelete,
        isSubFolder,
      },
      type: actionTypes.FOLDER_DELETE,
    })
  );

export const resetFolder = () => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {},
      type: actionTypes.FOLDER_RESET,
    })
  );

export const setDataPackagesFromEntry = ruidEntry => dispatch =>
  Promise.resolve(
    dispatch({
      payload: ruidEntry,
      type: actionTypes.FOLDER_SET_DATA_PACKAGES_FROM_ENTRY,
    })
  );

export const clearDataPackagesFromEntry = () => dispatch =>
  Promise.resolve(
    dispatch({
      type: actionTypes.FOLDER_CLEAR_DATA_PACKAGES_FROM_ENTRY,
    })
  );

export const addSelectedDataPackagesFromEntry = selectedRuids => dispatch =>
  Promise.resolve(
    dispatch({
      payload: selectedRuids,
      type: actionTypes.FOLDER_ADD_DATA_PACKAGES_FROM_ENTRY_TO_FOLDER,
    })
  );
